/* ============================================================
   KISHI KAISEI — moteur du quiz « Choisir mon couteau »
   ------------------------------------------------------------
   Deux étages.
   1. Les questions 1 à 3 classent les FAMILLES de lame.
   2. Dans chaque famille retenue, on choisit une RÉFÉRENCE
      précise : le budget filtre, le manche pousse, puis on
      départage.

   Règles arrêtées avec Lounis le 18 août 2026 :
   - L'acier n'entre JAMAIS dans le calcul. Égalité parfaite
     entre l'AUS10 et le 10Cr15CoMoV.
   - Le budget est le seul filtre dur, avec une tolérance de
     15 % en dessous et 20 % au-dessus.
   - Le manche est une préférence qui pousse, jamais une
     barrière : les manches techniques sont presque tous en
     haut de gamme, un filtre dur viderait le résultat.
   - Jamais deux fois le même couteau. Si une carte tombe sur
     un couteau déjà proposé, la carte disparaît. Le résultat
     affiche donc 1, 2 ou 3 couteaux.
   ============================================================ */
(function () {
  'use strict';

  var racine = document.querySelector('[data-kkq2]');
  if (!racine) return;

  var source = racine.querySelector('[data-kkq2-data]');
  var CAT = [];
  try { CAT = JSON.parse(source.textContent).produits || []; } catch (e) { return; }
  if (!CAT.length) return;

  var KLAVIYO_ID = racine.getAttribute('data-klaviyo') || '';
  var MEM = 'kk_quiz2';
  var GRAINE = 'kk_quiz2_seed';

  var FAMILLES = ['santoku', 'gyuto', 'nakiri', 'kiritsuke', 'petty'];
  var NOMS = { santoku: 'Santoku', gyuto: 'Gyuto', nakiri: 'Nakiri', kiritsuke: 'Kiritsuke', petty: 'Petty' };

  /* Tranches de budget, en centimes, redécoupées sur le catalogue réel
     le 18 août 2026 : 8 / 8 / 6 / 5 références, aucun trou. */
  var TRANCHES = {
    '1': [0, 8000],
    '2': [8000, 10000],
    '3': [10000, 12500],
    '4': [12500, Infinity]
  };
  var TOL_BAS = 0.85, TOL_HAUT = 1.20;

  var etapes = [].slice.call(racine.querySelectorAll('[data-kkq2-q]'));
  var intro = racine.querySelector('[data-kkq2-step="intro"]');
  var resultat = racine.querySelector('[data-kkq2-step="result"]');
  var barre = racine.querySelector('[data-kkq2-bar]');
  var fond = racine.querySelector('.kkq2-bg');
  var cartes = racine.querySelector('[data-kkq2-cards]');
  var vide = racine.querySelector('[data-kkq2-none]');

  var cur = 0, fini = false;

  /* Le tirage de départage doit rester stable pendant toute la session :
     sans cela, revenir en arrière puis avancer changerait le couteau. */
  var graine = (function () {
    try {
      var g = sessionStorage.getItem(GRAINE);
      if (!g) { g = String(Math.floor(Math.random() * 1e9)); sessionStorage.setItem(GRAINE, g); }
      return g;
    } catch (e) { return '7'; }
  })();

  function empreinte(txt) {
    var h = 0, s = txt + graine;
    for (var i = 0; i < s.length; i++) { h = ((h << 5) - h + s.charCodeAt(i)) | 0; }
    return Math.abs(h);
  }

  function euros(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  /* ---------- lecture des réponses ---------- */

  function choisies(etape) {
    return [].slice.call(etape.querySelectorAll('[aria-pressed="true"]'));
  }

  /* Tout cocher revient à ne rien dire : la question devient neutre. */
  function signal(etape) {
    var opts = [].slice.call(etape.querySelectorAll('.kkq2-opt'));
    var on = choisies(etape);
    if (!on.length || on.length === opts.length) return [];
    return on;
  }

  function lireScores() {
    var s = { santoku: 0, gyuto: 0, nakiri: 0, kiritsuke: 0, petty: 0 };
    var cadeau = false;
    etapes.forEach(function (et) {
      signal(et).forEach(function (b) {
        var pts = b.getAttribute('data-pts') || '';
        pts.split(',').forEach(function (p) {
          if (!p) return;
          var kv = p.split(':');
          if (s[kv[0]] !== undefined) s[kv[0]] += parseInt(kv[1], 10) || 0;
        });
        if (b.getAttribute('data-gift') === '1') cadeau = true;
      });
    });
    return { scores: s, cadeau: cadeau };
  }

  function lireBudget() {
    var et = racine.querySelector('[data-kkq2-q="budget"]');
    var on = signal(et).map(function (b) { return b.getAttribute('data-b'); });
    if (!on.length) return { min: 0, max: Infinity, libre: true, cles: [] };
    var min = Infinity, max = 0;
    on.forEach(function (k) {
      var t = TRANCHES[k];
      if (!t) return;
      var bas = t[0] === 0 ? 0 : t[0] * TOL_BAS;
      var haut = t[1] === Infinity ? Infinity : t[1] * TOL_HAUT;
      if (bas < min) min = bas;
      if (haut > max) max = haut;
    });
    return { min: min === Infinity ? 0 : min, max: max || Infinity, libre: false, cles: on };
  }

  function lireManche() {
    var et = racine.querySelector('[data-kkq2-q="manche"]');
    var on = signal(et).map(function (b) { return b.getAttribute('data-m'); })
      .filter(function (m) { return m === 'bois' || m === 'technique'; });
    return on;
  }

  /* ---------- choix des références ---------- */

  var PRIX_MAX_CAT = CAT.reduce(function (m, p) { return p.p > m ? p.p : m; }, 0);

  function centreBudget(bud) {
    var haut = bud.max === Infinity ? PRIX_MAX_CAT : bud.max;
    return (bud.min + haut) / 2;
  }

  function candidats(famille, bud, manches, pris) {
    return CAT.filter(function (p) {
      if (p.fam !== famille) return false;
      if (!p.dispo || p.q <= 0) return false;
      if (pris.indexOf(p.h) !== -1) return false;
      return p.p >= bud.min && p.p <= bud.max;
    }).sort(function (a, b) {
      if (manches.length) {
        var ma = manches.indexOf(a.m) !== -1 ? 0 : 1;
        var mb = manches.indexOf(b.m) !== -1 ? 0 : 1;
        if (ma !== mb) return ma - mb;
      }
      var c = centreBudget(bud);
      var da = Math.abs(a.p - c), db = Math.abs(b.p - c);
      if (da !== db) return da - db;
      if (a.q !== b.q) return b.q - a.q;
      return empreinte(a.h) - empreinte(b.h);
    });
  }

  function calcul() {
    var lu = lireScores();
    var bud = lireBudget();
    var manches = lireManche();

    var classement = FAMILLES.slice().sort(function (a, b) {
      if (lu.scores[b] !== lu.scores[a]) return lu.scores[b] - lu.scores[a];
      return FAMILLES.indexOf(a) - FAMILLES.indexOf(b);
    });

    /* Cadeau : le Kiritsuke, que nos propres fiches décrivent comme
       « exigeant », ne prend jamais la première carte. */
    if (lu.cadeau && classement[0] === 'kiritsuke') {
      classement.splice(0, 0, classement.splice(1, 1)[0]);
    }

    var pris = [], sortie = [];

    /* Carte 1 : la famille arrivée en tête. Si elle n'a aucun candidat
       dans le budget, on descend dans le classement. */
    var famPrincipale = null, premier = null;
    for (var i = 0; i < classement.length && !premier; i++) {
      var c = candidats(classement[i], bud, manches, pris);
      if (c.length) { premier = c[0]; famPrincipale = classement[i]; }
    }
    if (premier) {
      pris.push(premier.h);
      sortie.push({ role: 'Notre recommandation', p: premier });
    }

    /* Carte 2 : la meilleure autre forme de lame. */
    var second = null;
    for (var j = 0; j < classement.length && !second; j++) {
      if (classement[j] === famPrincipale) continue;
      var c2 = candidats(classement[j], bud, manches, pris);
      if (c2.length) second = c2[0];
    }
    if (second) {
      pris.push(second.h);
      sortie.push({ role: 'L’autre forme qui vous irait', p: second });
    }

    /* Carte 3 : la pièce supérieure de la famille principale, c'est-à-dire
       le plus cher de ses candidats encore dans le budget et plus cher que
       la carte 1. À défaut, un couteau d'appoint. */
    var troisieme = null, role3 = '';
    if (famPrincipale && premier) {
      var sup = candidats(famPrincipale, bud, manches, pris)
        .filter(function (p) { return p.p > premier.p; })
        .sort(function (a, b) { return b.p - a.p; });
      if (sup.length) { troisieme = sup[0]; role3 = 'Pour monter en gamme'; }
    }
    if (!troisieme && famPrincipale !== 'petty') {
      var app = candidats('petty', bud, manches, pris);
      if (app.length) { troisieme = app[0]; role3 = 'Le couteau d’appoint'; }
    }
    if (troisieme) {
      pris.push(troisieme.h);
      sortie.push({ role: role3, p: troisieme });
    }

    return { cartes: sortie, budget: bud, manches: manches, cadeau: lu.cadeau, scores: lu.scores, famille: famPrincipale };
  }

  /* ---------- affichage ---------- */

  function masquer() {
    intro.classList.remove('on');
    resultat.classList.remove('on');
    etapes.forEach(function (e) { e.classList.remove('on'); });
  }

  function montrerIntro() {
    fini = false;
    [].slice.call(racine.querySelectorAll('[aria-pressed="true"]')).forEach(function (b) { b.setAttribute('aria-pressed', 'false'); });
    try { sessionStorage.removeItem(MEM); } catch (e) {}
    masquer();
    intro.classList.add('on');
    barre.style.width = '0%';
  }

  function montrerQ(i) {
    masquer();
    etapes[i].classList.add('on');
    cur = i;
    barre.style.width = (((i + 1) / etapes.length) * 100) + '%';
    majSuivant();
  }

  /* « Suivant » reste actif même sans réponse : le visiteur a le droit de
     passer une question, ça vaut mieux qu'un blocage. Le libellé change. */
  function majSuivant() {
    var et = etapes[cur];
    var bouton = et.querySelector('[data-kkq2-next]');
    if (!bouton) return;
    var n = choisies(et).length;
    var dernier = cur === etapes.length - 1;
    bouton.textContent = dernier ? 'Voir mes couteaux →'
                                 : (n ? 'Suivant →' : 'Passer cette question →');
  }

  function echapper(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function carteHTML(item) {
    var p = item.p;
    var visuel = p.img
      ? '<img src="' + echapper(p.img) + '" alt="' + echapper(p.t) + '" loading="lazy">'
      : '<span>' + echapper(NOMS[p.fam] || '') + '</span>';
    return '<article class="kkq2-card">' +
      '<p class="kkq2-card-role">' + echapper(item.role) + '</p>' +
      '<div class="kkq2-card-ph">' + visuel + '</div>' +
      '<h3 class="kkq2-card-name">' + echapper(p.t) + '</h3>' +
      '<p class="kkq2-card-price">' + euros(p.p) + '</p>' +
      '<a class="kkq2-card-cta" href="/products/' + encodeURIComponent(p.h) + '">Voir le produit <span>→</span></a>' +
      '</article>';
  }

  function poserCartes(liste) {
    cartes.innerHTML = liste.map(carteHTML).join('');
    cartes.setAttribute('data-n', String(liste.length));
    vide.hidden = liste.length > 0;
    var avecPhoto = liste.filter(function (i) { return i.p.img; })[0];
    if (fond && avecPhoto) fond.style.backgroundImage = 'url(' + avecPhoto.p.img + ')';
    masquer();
    resultat.classList.add('on');
    barre.style.width = '100%';
  }

  function afficher(res) {
    fini = true;
    poserCartes(res.cartes);
    try {
      sessionStorage.setItem(MEM, JSON.stringify(res.cartes.map(function (i) { return [i.role, i.p.h]; })));
    } catch (e) {}
    envoyerKlaviyo(res);
  }

  /* ---------- Klaviyo ---------- */

  function emailConnu() {
    var champ = document.getElementById('kkPopEmail');
    var v = champ && champ.value ? champ.value.trim().toLowerCase() : '';
    if (v) return v;
    try {
      var l = JSON.parse(localStorage.getItem('kk_emails') || '[]');
      return l.length ? l[l.length - 1] : '';
    } catch (e) { return ''; }
  }

  function libellesEtape(nom) {
    var et = racine.querySelector('[data-kkq2-q="' + nom + '"]');
    if (!et) return [];
    return signal(et).map(function (b) { return (b.getAttribute('data-label') || '').trim(); }).filter(Boolean);
  }

  /* Les réponses partent sur le profil du visiteur, plus un événement.
     Sans email, on n'envoie rien : un abandon ne laisse aucune trace,
     c'est la limite assumée du dispositif. */
  function envoyerKlaviyo(res) {
    if (!KLAVIYO_ID) return;
    var email = emailConnu();
    if (!email) return;

    var props = {
      'Quiz usage': libellesEtape('usage'),
      'Quiz niveau': libellesEtape('niveau'),
      'Quiz destination': libellesEtape('cadeau'),
      'Quiz budget': libellesEtape('budget'),
      'Quiz manche': libellesEtape('manche'),
      'Quiz famille': res.famille ? NOMS[res.famille] : '',
      'Quiz couteaux': res.cartes.map(function (i) { return i.p.t; }),
      'Quiz cadeau': res.cadeau
    };

    var entete = { 'Content-Type': 'application/json', 'revision': '2024-10-15' };

    fetch('https://a.klaviyo.com/client/profiles/?company_id=' + KLAVIYO_ID, {
      method: 'POST', headers: entete,
      body: JSON.stringify({ data: { type: 'profile', attributes: { email: email, properties: props } } })
    })['catch'](function () {});

    fetch('https://a.klaviyo.com/client/events/?company_id=' + KLAVIYO_ID, {
      method: 'POST', headers: entete,
      body: JSON.stringify({
        data: {
          type: 'event',
          attributes: {
            properties: props,
            metric: { data: { type: 'metric', attributes: { name: 'Quiz termine' } } },
            profile: { data: { type: 'profile', attributes: { email: email } } }
          }
        }
      })
    })['catch'](function () {});
  }

  /* ---------- fin de parcours ---------- */

  /* La pop-up email sert de porte. Si son script n'est pas chargé, le
     résultat s'affiche directement : jamais de blocage. */
  function terminer() {
    var res = calcul(), dernier = cur;
    if (typeof window.kkEmailGate !== 'function') { afficher(res); return; }
    window.kkEmailGate(
      function () { afficher(res); },
      function () { if (!fini) montrerQ(dernier); }
    );
  }

  /* ---------- interactions ---------- */

  racine.addEventListener('click', function (e) {
    var el = e.target.closest ? e.target.closest('button') : null;
    if (!el) return;

    if (el.hasAttribute('data-kkq2-start')) { montrerQ(0); return; }

    if (el.classList.contains('kkq2-opt')) {
      el.setAttribute('aria-pressed', el.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
      majSuivant();
      return;
    }

    if (el.hasAttribute('data-kkq2-next')) {
      if (cur < etapes.length - 1) { montrerQ(cur + 1); } else { terminer(); }
      return;
    }

    if (el.hasAttribute('data-kkq2-back')) {
      if (cur > 0) { montrerQ(cur - 1); } else { montrerIntro(); }
      return;
    }

    if (el.hasAttribute('data-kkq2-restart')) { montrerIntro(); return; }
  });

  /* Au chargement : on restaure le dernier résultat s'il y en a un. La
     prévisualisation Shopify recharge la page après un envoi de formulaire,
     sans ça le visiteur repartirait de zéro. */
  (function () {
    var brut = null;
    try { brut = sessionStorage.getItem(MEM); } catch (e) {}
    if (brut) {
      try {
        var paires = JSON.parse(brut);
        var liste = paires.map(function (pr) {
          var p = CAT.filter(function (x) { return x.h === pr[1]; })[0];
          return p ? { role: pr[0], p: p } : null;
        }).filter(Boolean);
        if (liste.length) { fini = true; poserCartes(liste); return; }
      } catch (e) {}
    }
    montrerIntro();
  })();
})();
